import { USER_STATUS_CODE, ORDER_STATUS_CODE } from '@/utils/constants';

function getButtonStatesFromUserStatus(packList) {

  const userStatus = packList.userStatus;
  const purchaseType = packList.purchaseType;
  const curSeq = packList.curSeq;
  const buttonStates = {};
  const paymentType = packList.paymentType;

  switch (userStatus) {

    case USER_STATUS_CODE.PAYMENT_INSTALLMENT:
      buttonStates.paymentInstallment = true;
      break;

    // 마이팩 채팅 상담 예정
    case USER_STATUS_CODE.CONSULTATION_SCHEDULED_VCALL:
      if (purchaseType == 'single') {
        buttonStates.orderCancel = true;
        if (paymentType !== 'direct') {
          buttonStates.changePaymentInfo = true;
        }
        buttonStates.resendConsultationUrl = true;
      } else {
        buttonStates.cancelSubscription = true;
        buttonStates.changePaymentInfo = true;
        buttonStates.resendSubscriptionUrl = true;
      }
      break;

    // 마이팩 ABC 상담 예정
    case USER_STATUS_CODE.CONSULTATION_SCHEDULED_ABC:
      if (purchaseType == 'single') {
        buttonStates.orderCancel = true;
        if (paymentType !== 'direct') {
          buttonStates.changePaymentInfo = true;
        }
        buttonStates.resendConsultationInfo = true;
      } else {
        buttonStates.cancelSubscription = true;
        buttonStates.changePaymentInfo = true;
        buttonStates.resendConsultationInfo = true;
      }
      break;

    // 정기 구매 승인 예정
    case USER_STATUS_CODE.CONSULTATION_SCHEDULED_RECURRING:
      buttonStates.cancelSubscription = true;
      buttonStates.changePaymentInfo = true;
      buttonStates.approvedSubscription = true;
      break;

    // 마이팩 취소
    case USER_STATUS_CODE.CONSULTATION_CANCELED:
      buttonStates.reorder = true;
      break;

    // 정기 구매 승인 완료
    case USER_STATUS_CODE.RECURRING_PURCHASE_APPROVED:
      if (purchaseType == 'recurring') {
        buttonStates.cancelSubscription = true;
        buttonStates.changePaymentInfo = true;
      }
      break;

    // 단종 또는 재고 소진
    case USER_STATUS_CODE.PRODUCT_UNAVAILABLE:
      if (purchaseType == 'recurring') {
        buttonStates.cancelSubscription = true;
      }
      buttonStates.stockCheckAndCheckout = true;
      break;

    // 결제 실패
    case USER_STATUS_CODE.PAYMENT_FAILED:
      if (purchaseType == 'single') {
        buttonStates.checkout = true;
      } else if (purchaseType == 'recurring') {
        buttonStates.cancelSubscription = true;
        buttonStates.changePaymentInfo = true;
        buttonStates.checkout = true;
      }
      break;

    // 상담 미완료
    case USER_STATUS_CODE.CONSULTATION_INCOMPLETED:
      if (purchaseType == 'single') {
        buttonStates.reorder = true;
      } else if (purchaseType == 'recurring') {
        if(curSeq < 12) {
          buttonStates.cancelSubscription = true;
        }
        if (curSeq == 1 || curSeq == 12) {
          buttonStates.reorder = true;
        }
      }
      break;

    // 상담 및 결제 완료
    case USER_STATUS_CODE.PAYMENT_FINISHED:
      buttonStates.paymentCancel = true;
      break;

    // 마이팩 포장 시작
    case USER_STATUS_CODE.DIVISION_STARTED:
      break;

    // 마이팩 포장 완료
    case USER_STATUS_CODE.DIVISION_FINISHED:
      if (purchaseType == 'single') {
        buttonStates.reorder = true;
      } else if (purchaseType == 'recurring') {
        if (curSeq <= 11) {
          buttonStates.cancelSubscription = true;
        } else {
          buttonStates.reorder = true;
        }
      }
      break;

    // 마이팩 결제 취소
    case USER_STATUS_CODE.PAYMENT_CANCELED:
      if (purchaseType == 'single') {
        buttonStates.reorder = true;
        // buttonStates.checkout = true;
      } else if (purchaseType == 'recurring') {
        buttonStates.cancelSubscription = true;
        buttonStates.changePaymentInfo = true;
        buttonStates.checkout = true;
      }
      break;

    default: break;
  }
  return buttonStates;
}

function getButtonStatesFromOrderStatus(orderStatus) {
  const buttonStates = {
    paymentDone: false,
    divisionNotStart: false
  };

  switch (orderStatus) {
    case ORDER_STATUS_CODE.PAYMENT_FINISHED:
      buttonStates.paymentDone = false;
      buttonStates.divisionNotStart = true;
      break;

    case ORDER_STATUS_CODE.DIVISION_STARTED:
      buttonStates.paymentDone = false;
      buttonStates.divisionNotStart = false;
      break;

    case ORDER_STATUS_CODE.DIVISION_FINISHED:
      buttonStates.paymentDone = true;
      buttonStates.divisionNotStart = false;
      break;

    case ORDER_STATUS_CODE.PAYMENT_CANCELED:
      break;

    default: break;
  }
  return buttonStates;
}

export default {
  getButtonStatesFromUserStatus,
  getButtonStatesFromOrderStatus
};
